import Vue from 'vue';
import ReadModal from './read-modal.vue';

let instance;

function openReadModal(props = {}) {
  // 如果已存在实例，先销毁
  if (instance) {
    instance.$destroy();
    document.body.removeChild(instance.$el);
    instance = null;
  }

  // 创建组件构造器
  const ModalConstructor = Vue.extend(ReadModal);

  const { readOk, ...otherProps } = props;

  // 实例化组件
  instance = new ModalConstructor({
    propsData: {
      ...otherProps,
      show: true,
    },
  });

  // 注册readOk事件
  instance.$on('readOk', () => {
    if (readOk) {
      readOk();
    }
  });

  // 监听关闭事件
  instance.$on('close', () => {
    instance.visible = false;
    setTimeout(() => {
      instance.$destroy();
      document.body.removeChild(instance.$el);
      instance = null;
    });
  });

  // 挂载到 DOM
  instance.$mount();
  document.body.appendChild(instance.$el);

  return instance;
}

export default openReadModal;
